export function parseMarkdown(md) {
  if (!md) return "";
  
  // Check if content is already HTML (starts with <html> or <body>)
  if (md.trim().startsWith('<html') || md.trim().startsWith('<body')) {
    // Extract content from body tag or return the HTML as-is if no body tag
    const bodyMatch = md.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
    if (bodyMatch) {
      return bodyMatch[1].trim();
    }
    // If no body tag, look for content after head section
    const afterHeadMatch = md.match(/<\/head>\s*([\s\S]*?)(<\/html>|$)/i);
    if (afterHeadMatch) {
      return afterHeadMatch[1].trim();
    }
    return md.trim();
  }
  
  // Remove HTML link tags (like CSS stylesheets) from the beginning
  let content = md.replace(/<link[^>]*>/gi, '').trim();
  
  // Process content regardless of whether it looks like HTML or markdown
  let html = content
    // Preserve existing iframe tags
    .replace(/<iframe[^>]*>.*?<\/iframe>/gis, (match) => {
      // Ensure iframe has proper attributes for responsive display
      if (!match.includes('style=')) {
        return match.replace('<iframe', '<iframe class="tag-help-content__iframe"');
      }
      return match;
    })
    // Handle bold and italic text first (before line break conversion)
    .replace(/\*\*(.*?)\*\*/gim, "<strong>$1</strong>")
    .replace(/\*(.*?)\*/gim, "<em>$1</em>")
    // Handle lists (before line break conversion)
    .replace(/^\s*[*\-+]\s+(.*$)/gim, "<li>$1</li>")
    .replace(/^\s*\d+\.\s+(.*$)/gim, "<li>$1</li>")
    // Convert line breaks to HTML breaks
    .replace(/\n/g, "<br>")
    // Handle markdown headers AFTER converting line breaks to <br>
    // This ensures we can match the full header text properly
    .replace(/(^|<br>)\s*### ([^<]*?)(<br>|$)/gim, "$1<h3>$2</h3>$3")
    .replace(/(^|<br>)\s*## ([^<]*?)(<br>|$)/gim, "$1<h2>$2</h2>$3")
    .replace(/(^|<br>)\s*# ([^<]*?)(<br>|$)/gim, "$1<h1>$2</h1>$3")
  
  // Wrap consecutive list items in ul tags
  html = html.replace(/(<li>.*?<\/li>(?:<br><li>.*?<\/li>)*)/gs, "<ul>$1</ul>");
  
  // Clean up extra breaks around block elements
  html = html.replace(/<br>(<h[1-6])/g, "$1");
  html = html.replace(/(<\/h[1-6]>)<br>/g, "$1");
  html = html.replace(/<br>(<ul>)/g, "$1");
  html = html.replace(/(<\/ul>)<br>/g, "$1");
  
  // Remove double breaks that might interfere with styling
  html = html.replace(/<br><br>/g, "<br>");
  
  // Remove leading breaks at the start of content
  html = html.replace(/^(<br>\s*)+/g, "");
  
  // Ensure proper spacing around headers
  html = html.replace(/(<\/h[1-6]>)(<h[1-6])/g, "$1<br>$2");
  
  // Split into blocks and wrap non-block elements in paragraphs
  let result = html
    .split(/<br><br>|<br>\s*<br>/)
    .map(block => {
      // Don't wrap if it's already a block element
      if (block.match(/^<(h[1-6]|ul|ol|li|div)/i)) {
        return block;
      }
      // Don't wrap empty blocks
      if (block.trim() === '' || block.trim() === '<br>') {
        return '';
      }
      return `<p>${block}</p>`;
    })
    .filter(block => block.trim() !== '')
    .join("");
    
  // Final cleanup - remove any leading whitespace, breaks, or empty paragraphs
  result = result.replace(/^(\s|<br>|<p>\s*<\/p>)*/g, "").trim();

  return result;
}
